// ==============================|| CUSTOM FUNCTION - COLORS ||============================== //

const getColors = (theme, color) => {
    switch (color) {
        case 'secondary':
            return theme.palette.secondary;
        case 'error':
            return theme.palette.error;
        case 'warning':
            return theme.palette.warning;
        case 'info':
            return theme.palette.info;
        case 'success':
            return theme.palette.success;
        case 'black':
            return theme.palette.black;
        case 'blue':
            return theme.palette.blue;
        case 'actions':
            return theme.palette.actions;
        default:
            return theme.palette.primary;
    }
};

export default getColors;
